import { render, staticRenderFns } from "./uploadAttachments.vue?vue&type=template&id=ef37e53c&scoped=true&"
import script from "./uploadAttachments.vue?vue&type=script&lang=js&"
export * from "./uploadAttachments.vue?vue&type=script&lang=js&"
import style0 from "./uploadAttachments.vue?vue&type=style&index=0&id=ef37e53c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef37e53c",
  null
  
)

export default component.exports